import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },

    /* Estilização do container */
    container: {
    },

    /* Estilização do conteúdo dentro do container */
    paper: {
        padding: theme.spacing(3),
        display: 'inline-block',
        overflow: 'auto',
        flexDirection: 'row',
        backgroundColor: '#F5F5F5 !important',
    },

    formControl: {
        width: '100%',
        margin: theme.spacing(0.5),
        marginTop: '20px',
        minWidth: 'calc(100%)',
        backgroundColor: 'white'
    },

    selectEmpty: {
        marginTop: theme.spacing(2),
    },

    /* Estilização do títutlo */
    textTitle: {
        color: '#41414d',
        fontWeight: 600,
        marginBottom: 20,
    },

    textDescription: {
        padding: 10,
        backgroundColor: '#FFFBE8',
        color: 'rgba(0,0,0,0.8)',
        borderRadius: 7,
        width: '100%',
        fontFamily: 'Rawline'
    },

    buttonSubmit: {
        backgroundColor: '#1551B3 !important',
        color: '#fff !important',
        borderRadius: '20px !important',
        height: '45px !important',
        textTransform: 'capitalize !important',
        fontWeight: 'bold !important',
        fontSize: 15,
        marginTop: '17px !important',
        minWidth: '220px !important'
    }
}));

export default useStyles;